import axios from "axios";

const apiService = {
      // url: "http://127.0.0.1:8000",
      url: "https://api.spraynozzle.com.au",
      app_version: "1.0.0",
      auth: "",
      token: "",
      client_id: "AlT1EhQnhbCU9f9M2CkKznZPMHJgyEqvpHWTHAeL",
      client_secret:
            "QNEJyAnelmK1BJCsaWvPpHvIcN3iWZMtCGBZh5Crc6Kp5p6BBqyecQtZkJeGHa4bUk43zsw6quqsbuwCCMaL2QmV4o0MuNfSv5EkfohSYUOKHIl0hL8eL6Zaf8sVpcyG",

      getAccessToken: async (email, password, cb) => {
            try {
                  const formData = new URLSearchParams({
                        grant_type: "password",
                        client_id: apiService.client_id,
                        client_secret: apiService.client_secret,
                        username: email,
                        password: password,
                  });

                  const response = await fetch(apiService.url + "/o/token/", {
                        method: "POST",
                        headers: { "Content-Type": "application/x-www-form-urlencoded" },
                        body: formData,
                  });

                  if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.error_description || "Invalid credentials");
                  }

                  const data = await response.json();

                  if (!data.access_token) {
                        throw new Error("No access token received from API");
                  }

                  localStorage.setItem("access_token", data.access_token);
                  localStorage.setItem("refresh_token", data.refresh_token);
                  cb(true, data);
            } catch (error) {
                  console.error("Login Failed:", error.message);
                  cb(false, error);
            }
      },

      signupUser: async (userData, cb) => {
            try {
                  const signupResponse = await axios.post(apiService.url + "/api/signup/", userData, {
                        headers: {
                              "Content-Type": "application/json",
                        },
                  });

                  if (signupResponse.status !== 201) throw new Error("Signup failed");
                  cb(true, signupResponse);
            } catch (error) {
                  console.error("Signup Failed:", error.response ? error.response.data : error.message);
                  cb(false, error);
            }
      },

      refreshToken: async () => {
            try {
                  const refresh_token = localStorage.getItem("refresh_token");
                  if (!refresh_token) return null;

                  const formData = new URLSearchParams({
                        grant_type: "refresh_token",
                        client_id: apiService.client_id,
                        client_secret: apiService.client_secret,
                        refresh_token: refresh_token,
                  });

                  const response = await axios.post(apiService.url + "o/token/", formData, {
                        headers: {
                              "Content-Type": "application/x-www-form-urlencoded",
                        },
                  });

                  const { access_token, refresh_token: new_refresh_token } = response.data;

                  localStorage.setItem("access_token", access_token);
                  localStorage.setItem("refresh_token", new_refresh_token);

                  return access_token;
            } catch (error) {
                  console.error("OAuth2 Token Refresh Failed:", error.response ? error.response.data : error.message);
                  return null;
            }
      },

      logout: () => {
            localStorage.removeItem("access_token");
            localStorage.removeItem("refresh_token");
      },

      request: async (method, endpoint, data = null, headers = {}) => {
            let token = localStorage.getItem("access_token");

            try {
                  const response = await axios({
                        method,
                        url: `${apiService.url}${endpoint}`,
                        data,
                        headers: {
                              Authorization: token ? `Bearer ${token}` : "",
                              "Content-Type": "application/json",
                              ...headers,
                        },
                  });
                  return response.data;
            } catch (error) {
                  if (error.response && error.response.status === 401) {
                        // Try refreshing token
                        token = await apiService.refreshToken();
                        if (token) {
                              const retryResponse = await axios({
                                    method,
                                    url: `${apiService.url}${endpoint}`,
                                    data,
                                    headers: {
                                          Authorization: `Bearer ${token}`,
                                          "Content-Type": "application/json",
                                          ...headers,
                                    },
                              });
                              return retryResponse.data;
                        }
                  }
                  throw error.response ? error.response.data : error.message;
            }
      },

      get: async (endpoint, headers = {}) => {
            return apiService.request("GET", endpoint, null, headers);
      },

      post: async (endpoint, data, headers = {}) => {
            return apiService.request("POST", endpoint, data, headers);
      },

      patch: async (endpoint, data, headers = {}) => {
            return apiService.request("PATCH", endpoint, data, headers);
      },

      checkAuth: async (cb) => {
            let token = localStorage.getItem("access_token");
            if (!token) return cb(false, null);

            try {
                  let response = await axios.get(apiService.url + "api/user/", {
                        headers: { Authorization: `Bearer ${token}` },
                  });

                  cb(true, response.data);
            } catch (error) {
                  if (error.response && error.response.status === 401) {
                        token = await apiService.refreshToken();
                        if (!token) return cb(false, null);

                        return apiService.checkAuth(cb);
                  } else {
                        cb(false, error.response ? error.response.data : error.message);
                  }
            }
      },
};

export default apiService;

     //  url: "http://127.0.0.1:8000",
     //  url: "https://api.spraynozzle.com.au",
     //  app_version: "1.0.0",
     //  auth: "",
     //  token: "",
     //  client_id: "ffuLw3SLCwb3HG8hjQnx2DYfxPaZNToZmDiSV0ym",
     //  client_secret:"9F7qxkGXZ8299ygGI5zbM7ZL4h3UY2YZitYZXdq79l0qy29sR5QBEJ51ULN3Qeea5ESZfpv5RcDu4AddefcpcamFRL3yMlrLjpKIUle7P4aW5cDXE5PlxDX83scrGaCx",
